import { Injectable } from "@angular/core";
import { AngularFireAuth } from "@angular/fire/compat/auth";
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import type { User } from "firebase/auth";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class NoAuthGuardService {
  constructor(
    private router: Router,
    private auth: AngularFireAuth,
  ) {}

  // TODO: in the future this should only navigate if the user's email is verified
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean | Observable<boolean> | Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.auth.onAuthStateChanged((user: User) => {
        if (user) {
          this.router.navigate(["/dashboard"]);
          resolve(false);
        } else {
          resolve(true);
        }
      });
    });
  }
}
